module.exports = __webpack_public_path__ + "img/Vida y Salud.100bc120.svg";